const initialState = {
    document: {
        letterType: '',
        name: '',
        design: 'blank'
    },
    /** To handle Data between Step Change in Preboarding >> Generate Offer Data Save key as "PreBoardingId" */
    // "66c97edf1af8175cd91ed243(PreBoardingId)" : {
    //     authorValue: {
    //         other: {},
    //         employee: {},
    //         authorized: {},
    //     },
    //     placeHolder: {}
    // }
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SET_DOCUMENT': {
            return {...state, document: {...state.document, ...action.payload}};
        }

        case 'RELEASE_OFFER_LOCAL_STORE': {
            if (action.payload.action === "save_state" && action.payload.payload?.isUpdate) {
                state = JSON.parse(JSON?.stringify(state));
                delete  action.payload.payload.isUpdate // deleting Extra Keys
                return {...state, ...JSON.parse(JSON?.stringify(action.payload.payload))}
            }
            break;
        }
        default: {
            return state;
        }
    }
}

